/**
 * Language selector dropdown — div+button toggle (avoids theme details.js).
 */
(function () {
  var SELECTOR = '[data-tw-lang-selector]';

  function isOpen(wrapper) {
    var menu = wrapper.querySelector('.tw-language-selector-menu');
    return menu && !menu.hidden;
  }

  function closeSelector(wrapper) {
    var menu = wrapper.querySelector('.tw-language-selector-menu');
    var btn = wrapper.querySelector('[data-tw-lang-trigger]');
    wrapper.classList.remove('is-open');
    if (menu) menu.hidden = true;
    if (btn) btn.classList.remove('active');
  }

  function closeAll(except) {
    document.querySelectorAll(SELECTOR).forEach(function (wrapper) {
      if (wrapper !== except && isOpen(wrapper)) closeSelector(wrapper);
    });
  }

  function openSelector(wrapper) {
    closeAll(wrapper);
    var menu = wrapper.querySelector('.tw-language-selector-menu');
    var btn = wrapper.querySelector('[data-tw-lang-trigger]');
    wrapper.classList.add('is-open');
    if (menu) menu.hidden = false;
    if (btn) btn.classList.add('active');
  }

  function bindSelectors() {
    document.querySelectorAll(SELECTOR).forEach(function (wrapper) {
      if (wrapper.getAttribute('data-tw-lang-bound') === '1') return;
      wrapper.setAttribute('data-tw-lang-bound', '1');

      var btn = wrapper.querySelector('[data-tw-lang-trigger]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isOpen(wrapper)) {
          closeSelector(wrapper);
        } else {
          openSelector(wrapper);
        }
      });
    });
  }

  function bindOutsideClose() {
    document.addEventListener('click', function (e) {
      document.querySelectorAll(SELECTOR).forEach(function (wrapper) {
        if (!isOpen(wrapper)) return;
        if (wrapper.contains(e.target)) return;
        closeSelector(wrapper);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  function bindLangifyCookie() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest(SELECTOR + ' a[data-value]');
      if (!link) return;
      var code = link.getAttribute('data-value');
      if (!code) return;
      try {
        if (typeof LyHelper !== 'undefined' && LyHelper.setCookie) {
          LyHelper.setCookie('ly-lang-selected', code, 365);
        }
      } catch (err) {}
    });
  }

  function init() {
    if (!document.querySelector(SELECTOR)) return;
    bindSelectors();
    bindOutsideClose();
    bindLangifyCookie();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
